export default [
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/contacts-co',
    name: 'contacts_co',
    component: () => import("@/pages/Contacts/ContactsCoTable"),
    meta: {
      roles: ['CO_ROLE', 'REGION_ROLE', 'ADMIN_ROLE'],
      needContact: true,
      adminNeedAsOrgAuth: true,
    }
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/contacts-regions',
    name: 'contacts_regions',
    component: () => import("@/pages/Contacts/ContactsRegionsTable"),
    meta: {
      roles: ['CO_ROLE', 'REGION_ROLE', 'ADMIN_ROLE', 'FOUNDER_ROLE'],
      needContact: true,
      adminNeedAsOrgAuth: true,
    }
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/approval-regions',
    name: 'approval-regions',
    component: () => import("@/pages/Co/ApprovalRegions"),
    meta: {
      roles: ['CO_ROLE', 'ADMIN_ROLE'],
      needContact: true,
      adminNeedAsOrgAuth: true,
    }
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/approval-regions-alt',
    name: 'approval-regions-alt',
    component: () => import("@/pages/Co/ApprovalRegionsAlt.vue"),
    meta: {
      roles: ['CO_ROLE', 'FOUNDER_ROLE', 'ADMIN_ROLE'],
      needContact: true,
      adminNeedAsOrgAuth: true,
      title: "Согласование общих объемов КЦП субъектов на 2025/26 учебный год"
    }
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/methods',
    name: 'methods',
    component: () => import("@/pages/Metodics/Metodics"),
    meta: {
      needContact: true,
      adminNeedAsOrgAuth: true,
      roles: ['CO_ROLE', 'REGION_ROLE', 'ADMIN_ROLE'],
    }
  },
  //user pages
  // {
  //   path: '/stage-1',
  //   name: 'stage-1',
  //   component: () => import('@/pages/Co/Stage1'),
  //   meta: {
  //     needContact: true,
  //     adminNeedAsOrgAuth: true,
  //     roles: ['CO_ROLE', 'ADMIN_ROLE'],
  //     title: 'Согласование общих объемов КЦП на 2025/26 учебный год (центры ответственности)'
  //   },
  //   props: true,
  // },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/stage-2',
    name: 'stage-2',
    component: () => import('@/pages/Regions/Stage2'),
    meta: {
      needContact: true,
      adminNeedAsOrgAuth: true,
      roles: ['REGION_ROLE', 'ADMIN_ROLE'],
      title: 'Согласование общих объемов КЦП на 2025/26 учебный год (субъекты РФ)'
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + '/stage-3',
    name: 'stage-3',
    component: () => import('@/pages/Co/Stage3'),
    meta: {
      needContact: true,
      adminNeedAsOrgAuth: true,
      roles: ['CO_ROLE', 'ADMIN_ROLE'],
      title: 'Согласование общих объемов КЦП на 2025/26 учебный год (центры ответственности)'
    },
    props: true,
  },
]